import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Pagination extends Component {
  renderPagination () {
    if (this.props.totalPages < 2) {
      return
    }

    const content = []

    for (let i = 1; i <= this.props.totalPages; ++i) {
      content.push((
        <button
          type="button"
          className={classNames('w-8 h-8 border border-coral block mr-2 mb-2 hover:bg-coral rounded-1/2 transition-colors duration-150 ease-in-out', { 'bg-coral': this.props.currentPage === i })} key={i} onClick={() => {
            this.props.onClick && this.props.onClick(i)
          }}
        >
          {i}
        </button>
      ))
    }

    return content
  }

  render () {
    return (
      <div className={classNames('w-full', this.props.className)}>
        <div className="flex items-center justify-center -mb-2">
          {this.renderPagination()}
        </div>
      </div>
    )
  }
}

Pagination.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired
}

export default Pagination
